import { render } from "./EstateTypeControl.vue?vue&type=template&id=0d80e3de&ts=true"
import script from "./EstateTypeControl.vue?vue&type=script&lang=ts"
export * from "./EstateTypeControl.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__